import * as config from './config.js'
import {deepCopy} from '../utility/utility.js'

let api = {
	/**查询当前部门的所有父级
	 * @param {object} data2 所有部门列表（树状）
	 * @param {number} nodeId2 当前查询的部门id
	 * 
	 * @return {object} arrRes 要返回的当前查询的所有父级
	 */
	getParent(data2, nodeId2) {
		var arrRes = []
		if (data2.length == 0) {
			if (!!nodeId2) {
				arrRes.unshift(nodeId2)
			}
			return arrRes;
		}
		let rev = (data, nodeId) => {
			// console.log('data++++', data, nodeId)
			for (var i = 0, length = data.length; i < length; i++) {
				let node = data[i]
				// console.log('node--------', node.id, nodeId, node.id == nodeId)
				if (node.id == nodeId) {
					arrRes.unshift(node)
					rev(data2, node.parent_id)
					break
				} else {
					if (!!node.children) {
						rev(node.children, nodeId)
					}
				}
			}
			return arrRes
		}
		arrRes = rev(data2, nodeId2)
		return arrRes;
	},

	/**查询当前部门的所有子级
	 * @param {object} data 所有部门列表（非树状）
	 * @param {number} id 当前查询的部门id
	 * 
	 * @return {object} arrRes 要返回的当前查询的所有子级
	 */
	getChild(data, id) {
		let arrRes = []
		for (let i = 0; i < data.length; i++) {
			const item = data[i];
			if (item.parent_id == id) {
				arrRes.push(item)
			}
		}
		console.log('arrRes', arrRes)
		return arrRes
	},

	/**获取父级id数组
	 * 
	 * @return {object} pidArr 要返回的所有父级id数组
	 */
	getPidArr () {
		let pidArr = []
		let list = config.departmentData.list
		for (let i = 0; i < list.length; i++) {
			let item = list[i]
			if (pidArr.indexOf(item.parent_id) === -1) {
				if (item.parent_id != undefined) {
					pidArr.unshift(item.parent_id)
				}
			}
		}
		return pidArr
	},


	/** 获取当前部门的信息（id，name等）
	 * @param {number} nodeId2 当前查询的部门id
	 */
	getDetail(id) {
		let allList = deepCopy(config.departmentData.list)
		for (let i = 0; i < allList.length; i++) {
			if (allList[i].id == id) {
				return allList[i]
			}
		}
	},

	/**获取部门列表
	 * 
	 * @return {object} newList 要返回的部门列表
	 */
	getDepartmentList () {
		let temArr = this.getPidArr()
		let allList = deepCopy(config.departmentData.list)
		let newList = []
		// console.log('temArr', temArr)

		//获取新部门列表 （部门不超过五级）
		let rev = (num) => {
			// console.log('num____________', num)
			let afterInfo = {}, children = []
			for (let i = 0; i < [...allList].length; i++) {
				let item = allList[i]
				let p_id = temArr[num]
				if (item.id == p_id) {
					afterInfo = item
				} else if (item.parent_id == p_id) {
					children.push(item)
				}
			}

			// 将新增的部门信息添加到同级部门的下方
			if (afterInfo.children) {
				afterInfo.children[0].id = afterInfo.children[0].parent_id + (children.length + 1)
				children.push(afterInfo.children[0])
			}
			afterInfo.children = children

			if (num + 1 < temArr.length) {
				rev(num + 1)
			} else {
				newList = [afterInfo]
			}
		}
		rev(0)
		// 部门列表（树状）供其他接口使用
		// config.departmentData.treeList = deepCopy(newList)
		// console.log('newList', newList)
		return newList
	},

	/**获取部门详情
	 * @param {object} data {id: number} 当前查询的部门id
	 * 
	 * @return {object} info 要返回的部门详情
	 */
	getDepartmentInfo (data) {
		let id = data.id
		let list = deepCopy(this.getParent(this.getDepartmentList(), id))
		// console.log('list', list)
		let ll = list.length-1
		let resData = {
			parent: list,
			children: list[ll].children ? list[ll].children : []
		}
		return resData 
	},

	/**获取所有未分组部门列表（上级部门列表）
	 * 不能选择当前部门和它的下级部门
	 * @param {object} data {id: number} 当前查询的部门id
	 * 
	 * @return {object} arrRes 要返回的上级部门列表
	 */
	getAllDepartment (data) {
		let id = data.id
		console.log('data参数', data)
		// let list = config.departmentData.treeList
		let list = this.getDepartmentList()
		// console.log('treeList', list)
		let arrRes = []
		let rev = (data, is_child, num, name) => {
			data.forEach(function (node, i) {
				let pNode = deepCopy(node)
				pNode.name = (name ? name : '') + node.name
				pNode.is_child = pNode.id === id ? true : is_child
				pNode.level = num + 1
				// console.log('pNode', pNode.level)
				delete pNode.children
				arrRes.push(pNode)
				if (node.children) {
					// true为该子数据
					rev(node.children, pNode.is_child,num+1, pNode.name + '/')
				}
			})
		}
		rev([...list], false, 0)
		return arrRes
	},

	/**添加/修改部门
	 * @param {object} data {parent_id, add, edit} 请求参数
	 * @param {number} parent_id 父级id
	 * @param {object} add 要添加的部门列表
	 * @param {object} edit 要修改的部门列表
	 * 
	 */
	updateDepartment (data) {
		// console.log('data', data)
		let allList = deepCopy(config.departmentData.list)
		// console.log('修改前', allList)
		let p_id = data.parent_id
		// 添加
		if (data.add && data.add.length != 0) {
			// console.log('添加操作', '')
			let add = data.add
			// 获取当前父级的详情
			let detail = this.getDetail(data.parent_id)
			for (let i = 0; i < add.length; i++) {
				let item = {
					// 添加id的规则，按顺序添加，数据库最后一个id值+1
					id: allList[allList.length-1].id+1,
					parent_id: data.parent_id,
					parent_name: detail.name,
					name: add[i]
				}
				allList.push(item)
			}
		}
		// 编辑
		if (data.edit && data.edit.length != 0) {
			// console.log('编辑操作', '')
			let edit = data.edit
			let rev = (num) => {
				for (let i = 0; i < allList.length; i++) {
					let aItem = allList[i], eItem = edit[num]
					if (aItem.id === eItem.id) {
						aItem.name = eItem.name
						if (num+1 < edit.length) {
							rev(num+1)
						} else {
							break
						}
					}
				}
			}
			rev(0)
		}
		// 删除
		if (data.delete && data.delete.length != 0) {
			// console.log('删除操作', '')
			let deleted = data.delete
			let len = deleted.length-1
			// console.log('delete', deleted)
			let rev = (num) => {
				// console.log('num---', num)
				let deleteI
				for (let i = 0; i < allList.length; i++) {
					let aItem = allList[i], dItem = deleted[num]
					if (aItem.id === dItem) {
						// console.log('要删除的', i)
						deleteI = i
					}
					if(aItem.parent_id === dItem) {
						allList[i].parent_id = p_id
					}
				}
				allList.splice(deleteI, 1)
				if (num-1>=0) {
					rev(num - 1)
				}
			}
			rev(len)
		}
		config.departmentData.list = allList
		// console.log('allList修改后', allList)
	},


	/**获取用户列表
	 */
	getUserList () {
		let list = deepCopy(config.userData.list)
		return list
	},

	/**更新用户数据
	 * @param {object} data  当前用户更新参数
	 * 
	 */
	updateUser(data) {
		let user_id = data.user_id
		let list = deepCopy(config.userData.list)
		for (let i = 0; i < list.length; i++) {
			if (list[i].user_id === user_id) {
				list[i].user_name =  data.user_name
				list[i].user_account = data.user_account
				list[i].password = data.password
				list[i].phone_no = data.phone_no
				list[i].email = data.email
				list[i].department_id = data.department_id
				list[i].role_id = data.role_id
			}
		}
		config.userData.list = list
	},

	/**修改用户状态
	 * @param {object} data {user_id: number}  当前用户user_id
	 * 
	 */
	changeUserStatus(data) {
		let user_id = data.user_id
		let list = deepCopy(config.userData.list)
		for (let i = 0; i < list.length; i++) {
			if (list[i].user_id === user_id) {
				let user_state = list[i].user_state
				list[i].user_state = user_state === '1' ? '0' : '1'
			}
		}
		config.userData.list = list
	},

	/**添加/更新/删除用户生物特接口
 * @param {object} data {user_id: number, type: 1,xxx: [] }  当前用户user_id,类型type 1指纹 2人脸 3员工卡
 * 
 */
	updateUserProfile(data) {
		let user_id = data.user_id
		let type = data.type
		let list = deepCopy(config.userData.list)
		for (let i = 0; i < list.length; i++) {
			if (list[i].user_id === user_id) {
				let value = type == 1 ? 'fingerprint' : type == 2 ? 'faceimage' : 'staffcard'
				list[i].userProfile[value] = data.data
			}
		}
		config.userData.list = list
	},
	

	/**获取角色列表
	 */
	getRoleList() {
		let list = deepCopy(config.roleData.list)
		return list
	},

	/**新增/修改角色数据
	 * @param {object} data  当前角色更新参数
	 * 
	 */
	updateRole(data) {
		let role_id = data.role_id
		let list = deepCopy(config.roleData.list)
		for (let i = 0; i < list.length; i++) {
			if (list[i].role_id == role_id) {
				list[i].role_name = data.role_name
				list[i].role_desc = data.role_desc
			}
		}
		config.roleData.list = list
	},

	/**删除角色数据
	 * @param {object} data  当前角色删除id
	 * 
	 */
	deleteRole(data) {
		let role_id = data.role_id
		let list = deepCopy(config.roleData.list)
		for (let i = 0; i < list.length; i++) {
			if (list[i].role_id == role_id) {
				list.splice(i, 1)
			}
		}
		config.roleData.list = list
	},
	
}

/**公共请求
 * @param {object} url 请求内容
 * @param {object} url 请求参数
*/
function post(url, data) {
	data = data || '';
	return new Promise(function (resolve, reject) {
		let res = {
			data: api[url](data)
		}
		resolve(res)
	})
}


let expUserApi = {
	// 获取部门列表
	getDepartmentList () {
		return post('getDepartmentList')
	},
	// 获取部门详情
	getDepartmentInfo (data) {
		return post('getDepartmentInfo', data)
	},
	// 获取所有未分组部门列表
	getAllDepartment (data) {
		return post('getAllDepartment', data)
	},
	// 添加/修改部门
	updateDepartment(data) {
		return post('updateDepartment', data)
	},
	// 获取用户列表
	getUserList() {
		return post('getUserList')
	},
	// 更新用户数据
	updateUser(data) {
		return post('updateUser', data)
	},
	// 修改用户状态
	changeUserStatus(data) {
		return post('changeUserStatus', data)
	},
	// 添加/更新/删除用户生物特接口
	updateUserProfile(data) {
		return post('updateUserProfile', data)
	},
	// 获取角色列表
	getRoleList() {
		return post('getRoleList')
	},
	// 新增/修改角色
	updateRole (data) {
		return post('updateRole', data)
	},
	// 删除角色
	deleteRole(data) {
		return post('deleteRole', data)
	}
}


export{
	expUserApi
}


//////////////////
// WEBPACK FOOTER
// ./static/js/exp/user.js
// module id = null
// module chunks = 